import { render, staticRenderFns } from "./ServiceCodeGRPSpecRateAddEdit.vue?vue&type=template&id=064aee45"
import script from "./ServiceCodeGRPSpecRateAddEdit.vue?vue&type=script&lang=js"
export * from "./ServiceCodeGRPSpecRateAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports